import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChooseChatroomPage } from './choose-chatroom';

@NgModule({
  declarations: [ChooseChatroomPage],
  imports: [IonicPageModule.forChild(ChooseChatroomPage)],
})
export class ChooseChatroomPageModule {}



// WEBPACK FOOTER //
// ./src/pages/choose-chatroom/choose-chatroom.module.ts